export enum CaseType {
  Funeral = 'Funeral',
  Medical = 'Medical',
}
